import React from "react";

import PropTypes from "prop-types";

import RbTextInput from "../RbTextInput";

const RbNumberInput = React.forwardRef(function RbNumberInput(props, ref) {
  const { locale, decimalScale, ...other } = props;

  const formatter = React.useMemo(() => {
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: decimalScale,
    });
  }, [locale, decimalScale]);

  const decimalSeparator = React.useMemo(() => {
    if (decimalScale <= 0) {
      return null;
    }
    const numberWithDecimalSeparator = 1.1;
    const parts = formatter.formatToParts(numberWithDecimalSeparator);
    return parts[1].value;
  }, [formatter, decimalScale]);

  const format = React.useCallback(
    (value) => {
      if (Number.isFinite(value)) {
        return formatter.format(value);
      }
      return value;
    },
    [formatter]
  );

  const parse = React.useCallback(
    (value) => {
      if (value === "") {
        return undefined;
      }
      let raw = value.replace(
        new RegExp(`[^\\d$${decimalSeparator}]`, "g"),
        ""
      );
      if (decimalSeparator !== ".") {
        raw = raw.replace(decimalSeparator, ".");
      }
      if (raw.endsWith(".")) {
        return value;
      }
      const number = Number(raw);
      if (!Number.isNaN(number)) {
        return number;
      }
      return value;
    },
    [decimalSeparator]
  );

  return <RbTextInput format={format} parse={parse} {...other} ref={ref} />;
});

RbNumberInput.propTypes = {
  decimalScale: PropTypes.number,
  locale: PropTypes.string,
  onChangeValue: PropTypes.func,
  value: PropTypes.any,
};

RbNumberInput.defaultProps = {
  decimalScale: 0,
  locale: "en",
  onChangeValue: undefined,
  value: undefined,
};

export default React.memo(RbNumberInput);
